export const portsConfig = {
    // Angular Development Server
    angular: {
        dev: 4202,
        defaultHost: 'localhost',
    },

    // Firebase Emulator Ports
    firebase: {
        ui: 4002,
        functions: 5004,
        firestore: 8081,
        auth: 9199,
        storage: 9201,
        database: 9002,
        pubsub: 8087,
        hosting: 5005,
    },

    // Test Runner Ports
    testing: {
        karma: 9876,
    },

    // URL Helpers
    urls: {
        angularDev: 'http://localhost:4202',
        functionsEmulator: 'http://localhost:5004',
        authEmulator: 'http://localhost:9199',
        firestoreEmulator: 'localhost:8081',
        storageEmulator: 'localhost:9201',
    },
}
